"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePdfWithContent = generatePdfWithContent;
exports.generatePdfWithContentV2 = generatePdfWithContentV2;
const axios_1 = __importDefault(require("axios"));
function generatePdfWithContent(content, templateUrls, url, key) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let pdfResponse = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: `${url}`,
                headers: {
                    'x-api-key': key,
                },
                data: {
                    meta: Object.assign(Object.assign({ pdfTemplateUrl: templateUrls('body'), headerTemplateUrl: templateUrls('header'), footerTemplateUrl: templateUrls('footer'), mailTemplateUrl: templateUrls('mail') }, (templateUrls('brand') && { brand: templateUrls('brand') })), (templateUrls('locale') && { locale: templateUrls('locale') })),
                    content,
                },
            });
            return pdfResponse;
        }
        catch (error) {
            throw error.response;
        }
    });
}
function generatePdfWithContentV2(meta, content, url, key) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            let pdfResponse = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: `${url}`,
                headers: {
                    'x-api-key': key,
                },
                data: {
                    meta,
                    content,
                },
            });
            return pdfResponse;
        }
        catch (error) {
            throw error.response;
        }
    });
}
